import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'



let authorizedRoutes = [];


/*let publicRoutes = [
	{
		path: '/',
		name: 'HelloWorld',
		component: HelloWorld
	},
];*/

// Public
// import publicRoutes from '@Public/router';
// authorizedRoutes.concat(publicRoutes);

import adminRoutes from '@/modules/admin/router';
authorizedRoutes = authorizedRoutes.concat(adminRoutes);

import authRoutes from '@/modules/auth/router';
authorizedRoutes = authorizedRoutes.concat(authRoutes);

import personRoutes from '@/modules/person/router';
authorizedRoutes = authorizedRoutes.concat(personRoutes);
import serviceRoutes from '@/modules/service/router';
authorizedRoutes = authorizedRoutes.concat(serviceRoutes);
import movementRoutes from '@/modules/movement/router';
authorizedRoutes = authorizedRoutes.concat(movementRoutes);

import typeadminRoutes from '@/modules/typeadmin/router';
authorizedRoutes = authorizedRoutes.concat(typeadminRoutes);

// Views Footer 
// import Privacy from '@/views/intern/Privacy';
// import Terms from '@/views/intern/Terms';
// import About from '@/views/intern/About';
// Autres routes : Par défaut
let otherRoutes = [
	// {
	// 	path: '/about',
	// 	name: 'about',
	// 	component: About,
	// 	meta: {
	// 		layout: 'public',
	// 	},
	// },
	// {
	// 	path: '/privacy-policy',
	// 	name: 'privacy-policy',
	// 	component: Privacy,
	// 	meta: {
	// 		layout: 'public',
	// 	},
	// },
	// {
	// 	path: '/terms-and-conditions',
	// 	name: 'terms-conditions',
	// 	component: Terms,
	// 	meta: {
	// 		layout: 'public',
	// 	},
	// },
]

// Création des routes du système
const routes = authorizedRoutes.concat(otherRoutes)

const router = createRouter({
	// history: createWebHistory(),
	history: createWebHashHistory(),
	routes,
	// base: process.env.VUE_APP_BASE_URL,
});

// Controle des auths
import store from '@/store/index';
router.beforeEach((to, from) => {
	// Check if the route requires authentication
	if (to.meta.requiresAuth && (!store.getters.loggedIn || !store.getters.accessToken)) {
		return '/';
		/*return {
			name: 'Login',
			query: { redirect: to.fullPath },
		};*/
	}
	// If authenticated or route is public, allow navigation
});


export default router